import React from 'react';
import StockOrders from '../components/management/StockOrders';

const StockOrdersPage = () => {
    return <StockOrders />;
};

export default StockOrdersPage;
